import React, { PureComponent } from 'react';
import { GigCardShell, Media, Title, SellerInfo, SellerLevel, Username, Price, Badge, Rating, CollectGig, Countdown } from '../../shared';
import { getCurrency, adaptGigData, getGigAssets, getRisingTalentExpVariation } from '../../utils';
import { Avatar } from '@fiverr/fit';
import translations from '../../translations.en.json';
import '@fiverr/globals';
import '../style.scss';

class ListViewMobile extends PureComponent {

    constructor(props) {
        super(props);

        i18n.add(translations);
    }

    getBadges(gig, showRisingTalentBadge) {
        const {
            is_featured,
            is_limited_edition,
            quality_choice,
            limited_edition_expires_at,
            is_pro,
            gig_id
        } = gig;
        const badges = [];

        if (is_limited_edition) {
            badges.push(
                <Badge key={`${gig_id}_badge_limited`} type="limited"/>,
                <Countdown key={`${gig_id}_countdown`} deadline={limited_edition_expires_at}/>
            );
        } else if (showRisingTalentBadge) {
            badges.push(<Badge key={`${gig_id}_badge_talent`} type="talent"/>);
        } else if (is_featured) {
            badges.push(<Badge key={`${gig_id}_badge_featured`} type="featured"/>);
        } else if (quality_choice) {
            badges.push(<Badge key={`${gig_id}_badge_choice`} type="choice"/>);
        }

        is_pro && badges.push(<Badge key={`${gig_id}_badge_pro`} type="pro"/>);

        return badges;
    }

    render() {
        const { gig, user, context = {}, updateCollections } = this.props,
            userId = user && user.userId || null,
            risingTalentExpVariation = getRisingTalentExpVariation(gig.type, context.abTests),
            limitDisplayedRatings = context.abTests && context.abTests.RATINGS_THRESHOLD_ONE_HUNDRED === 2,
            shouldRenderRating = (gig.rating > 0 || gig.is_pro || risingTalentExpVariation) && risingTalentExpVariation !== 2;

        adaptGigData(gig, {context});

        return (
            <GigCardShell key={gig.gig_id} type="list-view-card" gigId={gig.gig_id}>
                <div className="flex-row bottom-line">
                    <div className="col-media">
                        <a href={gig.gig_url} className="js-gig-card-imp-data">
                            <Media assets={getGigAssets(gig)} slideWidth={96} gigId={gig.gig_id} userId={userId}/>
                        </a>
                    </div>
                    <div className="col-gig-info">
                        <Title gigUrl={gig.gig_url} caption={gig.iwill_title}/>
                        {shouldRenderRating && !gig.is_limited_edition && <Rating score={gig.rating} votes={gig.rating_count} starSize={16} starCount={1} isPro={gig.is_pro} risingTalentExpVariation={risingTalentExpVariation === 3} limitDisplayedRatings={limitDisplayedRatings}/>}
                        {this.getBadges(gig, risingTalentExpVariation === 2)}
                        <CollectGig gigId={gig.gig_id} updateCollections={updateCollections} user={user} showCollMenu={false} icon="fa fa-ellipsis-v"/>
                    </div>
                </div>

                <SellerInfo>
                    {gig.is_seller_online && <span className="is-online"></span>}
                    <Avatar src={gig.seller_img}/>
                    <Username name={gig.seller_name} url={gig.seller_url} prefix={i18n.t('general.by')} context={context}/>
                    {gig.is_available_now && <Badge type="now" seller={gig.seller_name}/>}

                    {!risingTalentExpVariation && <SellerLevel level={gig.seller_level} isPro={gig.is_pro} isLimitedEdition={gig.is_limited_edition}/>}
                </SellerInfo>

                <Price gigUrl={gig.gig_url}
                    price={getCurrency(gig.price_i, true)}
                    showStartingAt={gig.show_starting_at}
                    isLimitedEdition={gig.is_limited_edition}
                    averagePrice={gig.average_price && getCurrency(gig.average_price, true)}
                    medianPrice={gig.median_price && getCurrency(gig.median_price, true)}/>

            </GigCardShell>
        );
    }
}

export default ListViewMobile;



// WEBPACK FOOTER //
// ./src/list_view_card/views/mobile.js